import * as XLSX from 'xlsx';

export function useExcelExport() {
  const exportToExcel = (data, filename, sheetName = 'Sheet1') => {
    if (!data || data.length === 0) {
      return;
    }

    try {
      const workbook = XLSX.utils.book_new();
      
      const worksheet = XLSX.utils.json_to_sheet(data);
      
      XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
      
      const colWidths = [];
      const range = XLSX.utils.decode_range(worksheet['!ref']);
      
      for (let C = range.s.c; C <= range.e.c; ++C) {
        let maxWidth = 10;
        for (let R = range.s.r; R <= range.e.r; ++R) {
          const cellAddress = XLSX.utils.encode_cell({ r: R, c: C });
          const cell = worksheet[cellAddress];
          if (cell && cell.v) {
            const cellValue = String(cell.v);
            maxWidth = Math.max(maxWidth, cellValue.length);
          }
        }
        colWidths.push({ wch: Math.min(maxWidth, 50) });
      }
      
      worksheet['!cols'] = colWidths;
      
      const timestamp = new Date().toISOString().slice(0, 19).replace(/:/g, '-');
      const finalFilename = `${filename}_${timestamp}.xlsx`;
      
      XLSX.writeFile(workbook, finalFilename);
      
    } catch (error) {
      throw error;
    }
  };

  const formatDataForExport = (data, columns) => {
    if (!data || !columns) return [];
    
    return data.map(row => {
      const formattedRow = {};
      columns.forEach(column => {
        if (column.key && row.hasOwnProperty(column.key)) {
          let value = row[column.key];
          
          if (column.type === 'currency' && value !== null && value !== undefined) {
            value = `$${parseFloat(value).toLocaleString('en-US', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            })}`;
          } else if (column.type === 'date' && value) {
            value = new Date(value).toLocaleDateString('en-US');
          } else if (column.type === 'number' && value !== null && value !== undefined) {
            value = parseFloat(value);
          }
          
          formattedRow[column.label || column.key] = value;
        }
      });
      return formattedRow;
    });
  };

  return {
    exportToExcel,
    formatDataForExport
  };
}
